import { request } from 'graphql-request'

const makeGraphqlRequest = async (query, vars) => {
  const graphqlUrl = `${window.location.origin}/graphql`
  const data = await request(graphqlUrl, query, vars)
  return data
}

export default makeGraphqlRequest
